import { scaffolderPlugin } from '@backstage/plugin-scaffolder';
import {
  createScaffolderFieldExtension,
  type FieldExtensionComponentProps,
} from '@backstage/plugin-scaffolder-react';
import {
  GitLabUsernameConditionalField,
  validateGitLabUsernameConditional,
} from './GitLabUsernameConditionalField';
import type { GitLabUsernameConditionalValue } from './GitLabUsernameConditionalField';

function GitLabUsernameConditionalWrapper(
  props: FieldExtensionComponentProps<GitLabUsernameConditionalValue, {}>,
) {
  return <GitLabUsernameConditionalField {...props} />;
}

export const GitLabUsernameConditionalFieldExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'GitLabUsernameConditional',
    component: GitLabUsernameConditionalWrapper,
    validation: async (data, validation, context) => {
      await validateGitLabUsernameConditional(
        data as GitLabUsernameConditionalValue | undefined,
        validation,
        context,
      );
    },
  }),
);
